import script from "./other-modbus-list.vue?vue&type=script&setup=true&lang=js"
export * from "./other-modbus-list.vue?vue&type=script&setup=true&lang=js"

import "./other-modbus-list.vue?vue&type=style&index=0&id=4ac67388&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac67388"]])

export default __exports__